/* =========================================================
   BABYCORD — SEPET ÖDÜLLERİ
   - Eşik geçilince hediyeleri (Pouch, Care Bag...) sepete otomatik ekler, altına inince çıkarır
   - Hediye satırında HEDİYE etiketi + Değiştir → renk seçme popup'ı
   - Progress bar: [data-bc-progress]
   - Sepete özel fırsat kartları: [data-bc-gift-picker]
   Veriyi ve tüm ayarları snippets/bc-gift-pouch.liquid sağlar.
   ========================================================= */
(function () {
  'use strict';

  var dataEl = document.getElementById('bc-gift-data');
  if (!dataEl) return;
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
  CFG.gifts = (CFG.gifts || []).filter(function (g) { return g.options && g.options.length; });
  CFG.offers = CFG.offers || { enabled: false, groups: [] };
  CFG.offers.groups = (CFG.offers.groups || []).filter(function (g) { return g.options && g.options.length; });

  /* ---------- kampanya süresi ---------- */
  var CAMP = CFG.campaign || { on: true };
  var CAMP_END = CAMP.end ? new Date(CAMP.end).getTime() : 0;
  function campaignActive() {
    if (!CAMP.on) return false;
    if (CAMP_END && !isNaN(CAMP_END) && Date.now() > CAMP_END) return false;
    return true;
  }
  function endLabel() {
    if (!CAMP_END || isNaN(CAMP_END)) return '';
    var left = CAMP_END - Date.now();
    if (left <= 0) return '';
    if (left < 48 * 3600 * 1000) {
      var h = Math.floor(left / 3600000), m = Math.floor((left % 3600000) / 60000), sec = Math.floor((left % 60000) / 1000);
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      return T.endsIn(pad(h) + ':' + pad(m) + ':' + pad(sec));
    }
    return T.endsOn(new Date(CAMP_END).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', timeZone: 'Europe/Istanbul' }));
  }

  /* ---------- METİNLER (istersen buradan değiştir) ---------- */
  var T = {
    giftTag: 'HEDİYE',
    change: 'Değiştir',
    free: 'Ücretsiz',
    pick: 'RENK SEÇİN',
    confirmNew: 'HEDİYEMİ EKLE',
    confirmEdit: 'SEÇİMİ KAYDET',
    decline: 'İstemiyorum',
    subtitle: function (price) { return (price ? price + ' değerindeki ' : '') + 'hediyenin rengini seç, sepette 0 TL.'; },
    remainingGift: function (amount, label) { return label + ' için <strong>' + amount + '</strong> kaldı'; },
    remainingShip: function (amount) { return 'Ücretsiz kargo için <strong>' + amount + '</strong> kaldı'; },
    allDone: 'Tebrikler! Tüm hediyelerin sepette.',
    shipLabel: 'Ücretsiz kargo',
    giftWaiting: function (label) { return label + ' seni bekliyor'; },
    giftWaitingBtn: 'Hediyeni seç',
    offersTitle: 'Sepetine özel fırsatlar',
    offersBadge: 'Sepetinize özel',
    offerLine: function (name, pct) { return name + ' modellerinde sepetine özel %' + pct + ' indirim'; },
    offerPct: function (pct) { return '%' + pct + ' indirim'; },
    addToCart: 'Sepete ekle',
    offerTag: 'SEPETE ÖZEL',
    offerSaving: 'Sepete özel indirim',
    subtotal: 'Ara toplam',
    shipping: 'Kargo',
    shippingFree: 'Ücretsiz',
    shippingLater: 'Ödeme adımında hesaplanır',
    total: 'TOPLAM',
    taxNote: 'Vergiler dahildir.',
    trust: 'Güvenli ödeme · Ücretsiz ve kolay iade',
    help: 'Bir sorunuz mu var?',
    helpLink: 'WhatsApp Hattı',
    added: 'Sepete eklendi',
    goCart: function (n) { return 'Sepete git (' + n + ')'; },
    keepShopping: 'Alışverişe devam et',
    giftUnlocked: function (label) { return label + 'n sepette'; },
    giftPick: 'Rengini seç',
    endsOn: function (d) { return 'Son gün: ' + d; },
    endsIn: function (t) { return 'Bitmesine ' + t; },
    pdpFooter: 'Hediyeler sepetine otomatik eklenir · rengini sepette seç',
    pdpShip: 'Ücretsiz kargo',
    pdpGift: function (names) { return names.join(' + ') + ' hediye'; },
    pdpOffer: function (names, pct) { return '+ ' + names.join(' ve ') + "'ta sepete özel %" + pct + ' indirim'; },
    homeEyebrow: 'Kampanya',
    homeDetails: 'Detaylar',
    homeClose: 'Kapat',
    homeIdle: 'Sepetin büyüdükçe hediyelerin açılır',
    homeShip: 'Ücretsiz kargo',
    homeShipSub: 'Tüm siparişlerde',
    homeGift: function (name) { return name + ' hediye'; },
    homeGiftPlus: function (prev) { return prev + ' hediyene ek olarak'; },
    homeFoot: 'Hediyeler sepetine otomatik eklenir, rengini sepette seçersin.',
    homeCta: 'Sepetine git',
    homeShop: 'Alışverişe başla',
    homeShopUrl: '/collections/tum-cantalar',
    savings: function (amount) { return 'Bu siparişte kazancın: <strong>' + amount + '</strong>'; }
  };

  var GIFT_PROP = '_bc_gift';
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var queued = false;
  var lastCart = null;
  var preloaded = false;
  var offerSel = {};   // fırsat kartlarında seçili ürün (grup id → variant id)

  /* ---------- yardımcılar ---------- */
  function store(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function api(path, body) {
    return nativeFetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return api('cart.js'); }
  function setQty(key, qty) { return api('cart/change.js', { id: key, quantity: qty }); }
  function addItem(variantId, props) {
    var item = { id: variantId, quantity: 1 };
    if (props) item.properties = props;
    return api('cart/add.js', { items: [item] });
  }
  function addGift(gift, variantId) {
    var p = {}; p[GIFT_PROP] = gift.id;
    return addItem(variantId, p);
  }

  // İndirim kodlarını Türkçe harf / büyük-küçük harf farkı gözetmeden karşılaştır (İ=I=i=ı, Ö=O ...)
  function normCode(c) {
    return String(c || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function giftById(id) { for (var i = 0; i < CFG.gifts.length; i++) if (CFG.gifts[i].id === id) return CFG.gifts[i]; return null; }
  // Hediye ürünleri ürün kimliğinden tanınır: sepete nasıl eklenirse eklensin hediye sayılır
  // Fırsat kopyaları (gizli %30'luk ürünler) ve orijinalleri
  var OFFER_PRODUCTS = [];        // kopya ürün kimlikleri
  var CLONE_INFO = {};            // kopya product_id → { group, was_cents, title }
  function normTitle(t) {
    return String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  (CFG.offers.groups || []).forEach(function (g) {
    g.options.forEach(function (o) {
      OFFER_PRODUCTS.push(o.product_id);
      CLONE_INFO[o.product_id] = { group: g, was: o.was_cents, title: o.title };
    });
  });
  function isClone(item) { return OFFER_PRODUCTS.indexOf(item.product_id) !== -1; }
  function originalFor(item) {
    var info = CLONE_INFO[item.product_id];
    if (!info) return null;
    var key = normTitle(info.title);
    var list = info.group.originals || [];
    for (var i = 0; i < list.length; i++) if (normTitle(list[i].title) === key) return list[i];
    return null;
  }
  var GIFT_BY_PRODUCT = {};
  CFG.gifts.forEach(function (g) { g.options.forEach(function (o) { GIFT_BY_PRODUCT[o.product_id] = g.id; }); });

  function giftIdOf(item) {
    if (GIFT_BY_PRODUCT[item.product_id]) return GIFT_BY_PRODUCT[item.product_id];
    var v = item.properties && item.properties[GIFT_PROP];
    if (v && giftById(v)) return v;
    return null;
  }
  function giftLines(cart, id) { return cart.items.filter(function (i) { return giftIdOf(i) === id; }); }
  function currentGiftLine(id) { return lastCart ? giftLines(lastCart, id)[0] || null : null; }

  // Eşik hesabı: hediyeler hariç, indirimler uygulanmış tutar
  function baseTotal(cart) {
    return cart.items.reduce(function (s, i) { return giftIdOf(i) ? s : s + i.final_line_price; }, 0);
  }

  function optionIn(list, variantId) { for (var i = 0; i < list.length; i++) if (list[i].variant_id === variantId) return list[i]; return null; }
  function firstAvailable(list) { for (var i = 0; i < list.length; i++) if (list[i].available) return list[i]; return null; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Mağazanın para formatıyla yaz (noDecimals: kuruşsuz)
  function money(cents, noDecimals) {
    var fmt = CFG.money_format || '{{amount}} TL';
    function fmtNum(n, dec, thou, decSep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      var withComma = key.indexOf('comma') !== -1;
      var thou = withComma ? '.' : ',';
      var dec = withComma ? ',' : '.';
      if (noDecimals || key.indexOf('no_decimals') !== -1) return fmtNum(cents, 0, thou, dec);
      return fmtNum(cents, 2, thou, dec);
    });
  }

  function refreshCartUI() { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }

  function cartVisible() {
    if (/\/cart\/?$/.test(window.location.pathname)) return true;
    var d = document.getElementById('Cart-Drawer');
    return !!(d && d.classList.contains('active'));
  }

  function preloadImages() {
    if (preloaded) return;
    preloaded = true;
    CFG.gifts.forEach(function (g) {
      g.options.forEach(function (o) {
        if (o.image) { var a = new Image(); a.src = o.image; }
        if (o.thumb) { var b = new Image(); b.src = o.thumb; }
      });
    });
  }

  /* ---------- ana mantık ---------- */
  async function sync() {
    if (busy) { queued = true; return; }
    busy = true;
    var changed = false;
    var autoAdded = null;
    try {
      var cart = await getCart();
      var base = baseTotal(cart);

      for (var g = 0; g < CFG.gifts.length; g++) {
        var gift = CFG.gifts[g];
        var lines = giftLines(cart, gift.id);
        var kHad = 'bc_gift_had_' + gift.id, kDec = 'bc_gift_declined_' + gift.id;

        if (campaignActive() && base >= gift.threshold) {
          if (!lines.length) {
            if (store(kHad) === '1') store(kDec, '1'); // müşteri hediyeyi kendisi sildi
            if (store(kDec) !== '1') {
              var opt = firstAvailable(gift.options);
              if (opt) { await addGift(gift, opt.variant_id); changed = true; if (!autoAdded) autoAdded = gift.id; }
            }
          } else {
            for (var i = 0; i < lines.length; i++) {
              var want = i === 0 ? 1 : 0;
              if (lines[i].quantity !== want) { await setQty(lines[i].key, want); changed = true; }
            }
          }
        } else {
          store(kDec, null);
          for (var j = 0; j < lines.length; j++) { await setQty(lines[j].key, 0); changed = true; }
        }
      }

      // Fırsat kopyaları: eşik sağlanmıyorsa kopyaları normal fiyatlı orijinalleriyle değiştir
      var offerOk = campaignActive() && CFG.offers.enabled && offerBase(cart) >= CFG.offers.threshold;
      if (!offerOk) {
        var clones = cart.items.filter(isClone);
        for (var c = 0; c < clones.length; c++) {
          var cl = clones[c], orig = originalFor(cl);
          await setQty(cl.key, 0);
          if (orig && orig.available) { try { await api('cart/add.js', { items: [{ id: orig.variant_id, quantity: cl.quantity }] }); } catch (e) {} }
          changed = true;
        }
      }

      // (Eski yöntem) Fırsat indirim kodu: eşik geçilince ve sepette fırsat ürünü varken ekle, yoksa çıkar
      if (CFG.offers.code) {
        var mine = normCode(CFG.offers.code);
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var has = codes.some(function (c) { return normCode(c) === mine; });
        var hasOfferItem = cart.items.some(function (i) { return !giftIdOf(i) && OFFER_PRODUCTS.indexOf(i.product_id) !== -1; });
        var want = campaignActive() && CFG.offers.enabled && hasOfferItem && offerBase(cart) >= CFG.offers.threshold;
        if (want !== has) {
          var others = codes.filter(function (c) { return normCode(c) !== mine; });
          await api('cart/update.js', { discount: (want ? others.concat([CFG.offers.code]) : others).join(',') });
          changed = true;
        }
      }

      if (changed) cart = await getCart();
      CFG.gifts.forEach(function (gf) { store('bc_gift_had_' + gf.id, giftLines(cart, gf.id).length ? '1' : null); });
      lastCart = cart;
      if (CFG.gifts.length && base >= CFG.gifts[0].threshold) preloadImages();
      decorate();
    } catch (e) {
      console.warn('[bc-gift]', e);
    } finally {
      busy = false;
      if (changed) refreshCartUI();
      // Hediye popup'ı: sepet görünüyorsa, rengi henüz seçilmemiş ilk hediye için bir kez aç
      setTimeout(function () {
        if (!cartVisible() || (modal && modal.classList.contains('is-open'))) return;
        var g = unseenGift();
        if (g) { markSeen(g.id); openModal(g.id); }
      }, 600);
      if (queued) { queued = false; sync(); }
    }
  }

  function markSeen(id) { store('bc_gift_shown_' + id, '1'); }
  function unseenGift() {
    for (var i = 0; i < CFG.gifts.length; i++) {
      var g = CFG.gifts[i];
      if (currentGiftLine(g.id) && store('bc_gift_shown_' + g.id) !== '1') return g;
    }
    return null;
  }

  async function applyChoice(giftId, variantId) {
    var gift = giftById(giftId);
    var line = currentGiftLine(giftId);
    if (!gift || (line && line.variant_id === variantId)) return;
    markRowsLoading(giftId);
    busy = true;
    try {
      if (line) await setQty(line.key, 0);
      await addGift(gift, variantId);
      store('bc_gift_declined_' + giftId, null);
      store('bc_gift_had_' + giftId, '1');
      lastCart = await getCart();
    } catch (e) { console.warn('[bc-gift]', e); }
    busy = false;
    refreshCartUI();
  }

  async function declineGift(giftId) {
    var line = currentGiftLine(giftId);
    store('bc_gift_declined_' + giftId, '1');
    if (!line) return;
    markRowsLoading(giftId);
    busy = true;
    try {
      await setQty(line.key, 0);
      store('bc_gift_had_' + giftId, null);
      lastCart = await getCart();
    } catch (e) { console.warn('[bc-gift]', e); }
    busy = false;
    refreshCartUI();
  }

  async function addOffer(variantId, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    busy = true;
    try {
      await addItem(variantId);
      lastCart = await getCart();
    } catch (e) { console.warn('[bc-gift]', e); }
    busy = false;
    if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    document.querySelectorAll('[data-bc-gift-picker]').forEach(function (el) { el.__bcHtml = null; });
    refreshCartUI();
    sync();
  }

  /* ---------- sepet satırları: HEDİYE etiketi + Değiştir ---------- */
  function rowsForKey(key) {
    var rows = [];
    document.querySelectorAll('[data-key]').forEach(function (el) {
      if (el.getAttribute('data-key') !== key) return;
      var row = el.closest('tr.cart-item') || el.closest('.product-card-small');
      if (row && rows.indexOf(row) === -1) rows.push(row);
    });
    return rows;
  }

  function markRowsLoading(giftId) {
    var line = currentGiftLine(giftId);
    if (line) rowsForKey(line.key).forEach(function (r) { r.classList.add('loading', 'bc-gift-line--loading'); });
  }

  // Temanın ürün satırlarında gösterdiği 0 TL'lik indirim etiketlerini gizle
  // (X al Y kazan'da eşiği dolduran ürünler Shopify tarafından 0 TL indirimle işaretlenir)
  function hideZeroDiscounts() {
    document.querySelectorAll('.discounts__discount').forEach(function (li) {
      var amount = (li.textContent.split('(-')[1] || '').replace(/[^0-9]/g, '');
      if (amount && /^0+$/.test(amount)) {
        li.style.display = 'none';
      }
    });
    document.querySelectorAll('ul.discounts').forEach(function (ul) {
      var visible = Array.prototype.some.call(ul.children, function (li) { return li.style.display !== 'none'; });
      if (!visible) ul.style.display = 'none';
    });
  }

  // Hediye ürünlerinin kartlarını sitede gizle (öneriler, arama, hızlı arama, koleksiyonlar)
  var GIFT_HANDLES = [];
  CFG.gifts.forEach(function (g) { g.options.forEach(function (o) { if (o.handle) GIFT_HANDLES.push(o.handle); }); });
  (CFG.offers.groups || []).forEach(function (g) { g.options.forEach(function (o) { if (o.handle) GIFT_HANDLES.push(o.handle); }); });

  function hideGiftCards() {
    if (!GIFT_HANDLES.length) return;
    document.querySelectorAll('product-card, .product-card').forEach(function (card) {
      if (card.__bcChecked) return;
      card.__bcChecked = true;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m || GIFT_HANDLES.indexOf(decodeURIComponent(m[1])) === -1) return;
      // kartı tutan ızgara hücresini gizle (boşluk kalmasın), yoksa kartın kendisini
      var cell = card.closest('.swiper-slide, li, .column, .columns');
      if (!cell || cell.querySelectorAll('product-card, .product-card').length > 1) cell = card;
      cell.style.display = 'none';
    });
  }

  // Kutuları temaya kendimiz yerleştir (tema dosyalarına satır eklemek gerekmez; güncellemeye dayanıklı)
  function ensureContainers() {
    // Sepet sayfası
    document.querySelectorAll('#cart-form').forEach(function (form) {
      var title = form.querySelector('.thb-cart-form--title');
      if (title && !form.querySelector('[data-bc-progress]')) title.insertAdjacentHTML('beforebegin', '<div data-bc-progress></div>');
      var table = form.querySelector('table.cart-items');
      if (table && !form.querySelector('[data-bc-gift-picker]')) table.insertAdjacentHTML('afterend', '<div data-bc-gift-picker></div>');
    });
    // Sepet çekmecesi (açıksa)
    document.querySelectorAll('.cart-drawer .product-card-small--container').forEach(function (box) {
      if (!box.querySelector('[data-bc-progress]')) box.insertAdjacentHTML('afterbegin', '<div data-bc-progress></div>');
      if (!box.querySelector('[data-bc-gift-picker]')) {
        var removeAll = box.querySelector('remove-all');
        if (removeAll) removeAll.insertAdjacentHTML('beforebegin', '<div data-bc-gift-picker></div>');
        else box.insertAdjacentHTML('beforeend', '<div data-bc-gift-picker></div>');
      }
    });
  }

  /* ---------- ürün sayfası: kampanya kutusu (Sepete ekle butonunun altı) ---------- */
  function renderPdp() {
    if (CFG.page !== 'product') return;
    var forms = document.querySelectorAll('product-form.product-form');
    var active = campaignActive() && !CFG.product_gift && CFG.gifts.length;
    forms.forEach(function (form) {
      if (form.closest('#Product-Drawer')) return;
      var box = form.parentNode.querySelector(':scope > .bc-pdp');
      if (!active) { if (box) box.remove(); return; }

      var base = lastCart ? baseTotal(lastCart) : 0;
      var rows = [];
      if (CFG.shipping > 0) rows.push({ t: CFG.shipping, title: T.pdpShip, thumbs: [] });
      var names = [], thumbs = [];
      CFG.gifts.forEach(function (g) {
        names.push(g.name || g.label);
        g.options.slice(0, 6).forEach(function (o) { if (o.thumb) thumbs.push(o.thumb); });
        var row = { t: g.threshold, title: T.pdpGift(names.slice()), thumbs: thumbs.slice(-6) };
        var O = CFG.offers;
        if (O && O.enabled && O.threshold === g.threshold && O.groups.length) {
          row.sub = T.pdpOffer(O.groups.map(function (x) { return x.name; }), O.percent);
        }
        rows.push(row);
      });
      rows.sort(function (a, b) { return a.t - b.t; });

      var html = '<div class="bc-pdp__head"><span>' + esc(CAMP.name || '') + '</span><span data-bc-countdown>' + endLabel() + '</span></div>' +
        rows.map(function (r) {
          var done = base >= r.t;
          return '<div class="bc-pdp__row' + (done ? ' is-done' : '') + '">' +
            '<div class="bc-pdp__amt">' + money(r.t, true) + '+' + (done ? '<span class="bc-pdp__ok">' + ICON_CHECK + '</span>' : '') + '</div>' +
            '<div class="bc-pdp__body"><p class="bc-pdp__title">' + esc(r.title) + '</p>' +
              (r.sub ? '<p class="bc-pdp__sub">' + esc(r.sub) + '</p>' : '') +
              (r.thumbs.length ? '<div class="bc-pdp__thumbs">' + r.thumbs.map(function (src) {
                return '<img src="' + src + '" alt="" loading="lazy" width="52" height="52">';
              }).join('') + '</div>' : '') +
            '</div></div>';
        }).join('') +
        '<div class="bc-pdp__foot">' + T.pdpFooter + '</div>';

      if (!box) {
        form.insertAdjacentHTML('afterend', '<div class="bc-pdp"></div>');
        box = form.parentNode.querySelector(':scope > .bc-pdp');
      }
      var key = html.replace(/<span data-bc-countdown>[^<]*<\/span>/g, '');
      if (box.__bcKey !== key) { box.innerHTML = html; box.__bcKey = key; }
    });
  }

  /* ---------- ana sayfa: slider altı kampanya bandı (açılır/kapanır) ---------- */
  var HOME_OPEN_KEY = 'bc_home_open';
  function renderHome() {
    if (CFG.page !== 'index') return;
    var band = document.querySelector('.bc-home');
    var active = campaignActive() && CFG.gifts.length;
    if (!active) { if (band) band.remove(); return; }

    if (!band) {
      // 1) Temada [data-bc-home] varsa oraya, 2) yoksa ilk slider bölümünün hemen altına
      var slot = document.querySelector('[data-bc-home]');
      var slider = document.querySelector('main [id^="shopify-section-"][id*="slideshow"]') ||
                   document.querySelector('[id^="shopify-section-"][id*="slideshow"]');
      if (!slot && !slider) return;
      var open = store(HOME_OPEN_KEY) === '1';
      var el = document.createElement('section');
      el.className = 'bc-home' + (open ? ' is-open' : '');
      el.setAttribute('aria-label', CAMP.name || 'Kampanya');
      el.innerHTML = '<div class="bc-home__in">' +
          '<button type="button" class="bc-home__bar" aria-expanded="' + open + '">' +
            '<span class="bc-home__lead"><span class="bc-home__icon">' + ICON_GIFT + '</span>' +
              '<span class="bc-home__name"></span><span class="bc-home__end" data-bc-countdown></span></span>' +
            '<span class="bc-home__steps"></span>' +
            '<span class="bc-home__toggle"><span class="bc-home__toggle-t"></span><span class="bc-home__plus" aria-hidden="true"></span></span>' +
          '</button>' +
          '<div class="bc-home__panel"><div class="bc-home__panel-in"></div></div>' +
        '</div>';
      if (slot) slot.appendChild(el); else slider.insertAdjacentElement('afterend', el);
      band = el;
      el.querySelector('.bc-home__bar').addEventListener('click', function () {
        var isOpen = band.classList.toggle('is-open');
        this.setAttribute('aria-expanded', isOpen);
        this.querySelector('.bc-home__toggle-t').textContent = isOpen ? T.homeClose : T.homeDetails;
        store(HOME_OPEN_KEY, isOpen ? '1' : null);
      });
    }

    var base = lastCart ? baseTotal(lastCart) : 0;
    var hasCart = lastCart && lastCart.item_count > 0;

    // basamaklar
    var tiers = [];
    if (CFG.shipping > 0) tiers.push({ t: CFG.shipping, title: T.homeShip, sub: T.homeShipSub, thumbs: [], ship: true });
    var prev = null;
    CFG.gifts.slice().sort(function (a, b) { return a.threshold - b.threshold; }).forEach(function (g) {
      var name = g.name || g.label;
      var subs = [];
      if (prev) subs.push(T.homeGiftPlus(prev));
      var O = CFG.offers;
      if (O && O.enabled && O.threshold === g.threshold && O.groups.length) {
        subs.push(T.pdpOffer(O.groups.map(function (x) { return x.name; }), O.percent).replace(/^\+\s*/, ''));
      }
      tiers.push({ t: g.threshold, title: T.homeGift(name), sub: subs.join(' · '),
        thumbs: g.options.filter(function (o) { return o.thumb; }).slice(0, 6).map(function (o) { return o.thumb; }) });
      prev = name;
    });
    tiers.sort(function (a, b) { return a.t - b.t; });

    // kapalı bar: kısa özet / sepet varsa kalan tutar
    var next = tiers.filter(function (x) { return base < x.t; })[0];
    var steps = hasCart
      ? '<span class="bc-home__status">' + (!next ? T.allDone
          : next.ship ? T.remainingShip(money(next.t - base, true))
          : T.remainingGift(money(next.t - base, true), next.title)) + '</span>'
      : tiers.map(function (x) {
          return '<span class="bc-home__step"><strong>' + money(x.t, true) + '+</strong> ' + esc(x.title) + '</span>';
        }).join('<span class="bc-home__dot" aria-hidden="true"></span>');

    var panel =
      '<div class="bc-home__grid">' +
        tiers.map(function (x, i) {
          var done = base >= x.t;
          var from = i ? tiers[i - 1].t : 0;
          var seg = Math.max(0, Math.min(100, ((base - from) / (x.t - from)) * 100));
          return '<div class="bc-home__tier' + (done ? ' is-done' : '') + '">' +
            '<div class="bc-home__seg" aria-hidden="true"><i style="width:' + seg.toFixed(1) + '%"></i></div>' +
            '<p class="bc-home__amt">' + money(x.t, true) + '+' + (done ? '<span class="bc-home__ok">' + ICON_CHECK + '</span>' : '') + '</p>' +
            '<p class="bc-home__title">' + esc(x.title) + '</p>' +
            (x.sub ? '<p class="bc-home__sub">' + esc(x.sub) + '</p>' : '') +
            (x.thumbs.length ? '<div class="bc-home__thumbs">' + x.thumbs.map(function (src) {
              return '<img src="' + src + '" alt="" loading="lazy" width="56" height="56">';
            }).join('') + '</div>'
            : (x.ship ? '<div class="bc-home__shipicon">' + ICON_TRUCK + '</div>' : '')) +
          '</div>';
        }).join('') +
      '</div>' +
      '<div class="bc-home__foot"><span>' + esc(T.homeFoot) + '</span>' +
        '<a class="bc-home__cta" href="' + (hasCart ? root + 'cart' : T.homeShopUrl) + '">' + (hasCart ? T.homeCta : T.homeShop) + '</a></div>';

    var isOpen = band.classList.contains('is-open');
    var key = (CAMP.name || '') + '|' + steps + '|' + panel + '|' + isOpen;
    if (band.__bcKey === key) return;
    band.__bcKey = key;
    band.querySelector('.bc-home__name').textContent = CAMP.name || '';
    band.querySelector('.bc-home__end').textContent = endLabel();
    band.querySelector('.bc-home__steps').innerHTML = steps;
    band.querySelector('.bc-home__toggle-t').textContent = isOpen ? T.homeClose : T.homeDetails;
    band.querySelector('.bc-home__panel-in').innerHTML = panel;
  }

  // Son 48 saatte geri sayım her saniye güncellenir
  setInterval(function () {
    if (!CAMP_END) return;
    var label = endLabel();
    document.querySelectorAll('[data-bc-countdown]').forEach(function (el) { if (el.textContent !== label) el.textContent = label; });
    // süre dolduğu an kampanyayı kapat
    if (CAMP.on && CAMP_END && Date.now() > CAMP_END && !window.__bcEnded) { window.__bcEnded = true; sync(); }
  }, 1000);

  // Ürün sayfasında gizlenecek tema mesaj kutuları (başlığında bu yazılardan biri geçenler)
  var HIDE_FLASH = ['Stilini Tamamla'];
  function hideFlashMessages() {
    document.querySelectorAll('flash-message').forEach(function (el) {
      if (el.__bcFlash) return;
      el.__bcFlash = true;
      var txt = el.textContent || '';
      if (HIDE_FLASH.some(function (w) { return txt.indexOf(w) !== -1; })) el.style.setProperty('display', 'none', 'important');
    });
  }

  function decorate() {
    hideFlashMessages();
    ensureContainers();
    renderPdp();
    renderHome();
    hideGiftCards();
    hideZeroDiscounts();
    if (!lastCart) return;
    // Fırsat kopyası satırları: SEPETE ÖZEL etiketi, ürün sayfası linki kapalı
    lastCart.items.filter(isClone).forEach(function (line) {
      rowsForKey(line.key).forEach(function (row) {
        row.classList.add('bc-offer-line');
        row.querySelectorAll('a[href]').forEach(function (a) {
          if (!a.classList.contains('remove')) { a.removeAttribute('href'); a.removeAttribute('target'); }
        });
        if (row.querySelector('.bc-gift-meta')) return;
        var link = row.querySelector('.product-card-small--link');
        if (link) link.insertAdjacentHTML('afterend', '<div class="bc-gift-meta"><span class="bc-gift-tag">' + T.offerTag + '</span></div>');
      });
    });

    CFG.gifts.forEach(function (gift) {
      var line = currentGiftLine(gift.id);
      if (!line) return;
      rowsForKey(line.key).forEach(function (row) {
        row.classList.add('bc-gift-line');
        // hediye ürün sayfasına giden linkleri kapat (çöp kutusu hariç)
        row.querySelectorAll('a[href]').forEach(function (a) {
          if (!a.classList.contains('remove')) { a.removeAttribute('href'); a.removeAttribute('target'); }
        });
        // temanın "HEDİYE (-2.750 TL)" indirim satırını gizle; fiyatı tema zaten sağda gösteriyor
        row.querySelectorAll('ul.discounts').forEach(function (ul) { ul.style.display = 'none'; });
        if (row.querySelector('.bc-gift-meta')) return;
        var link = row.querySelector('.product-card-small--link');
        if (!link) return;
        link.insertAdjacentHTML('afterend',
          '<div class="bc-gift-meta"><span class="bc-gift-tag">' + T.giftTag + '</span>' +
          '<button type="button" class="bc-gift-change" data-bc-gift-open="' + esc(gift.id) + '">' + T.change + '</button></div>');
      });
    });
    renderProgress();
    renderOffers();
    renderSummary();
    renderTrust();
    if (toast && toast.classList.contains('is-open')) {
      var go = toast.querySelector('.bc-toast__go');
      if (go) go.textContent = T.goCart(lastCart.item_count);
      renderToastGift();
    }
  }

  /* ---------- ödeme butonunun altı: güven satırı + WhatsApp ---------- */
  var ICON_LOCK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var ICON_CHAT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.2A8.5 8.5 0 1 1 21 12z"/></svg>';

  function renderTrust() {
    if (!CFG.trust) return;
    var html = '<div class="bc-trust">' +
      '<p class="bc-trust__line">' + ICON_LOCK + '<span>' + T.trust + '</span></p>' +
      (CFG.whatsapp ? '<p class="bc-trust__help">' + T.help + ' <a href="https://wa.me/' + esc(CFG.whatsapp) +
        '" target="_blank" rel="noopener">' + ICON_CHAT + T.helpLink + '</a></p>' : '') +
    '</div>';
    // sepet sayfası: ödeme butonları kutusu; çekmece: buton alanı
    document.querySelectorAll('.proceed-to-checkout, .cart-drawer--buttons').forEach(function (box) {
      var el = box.querySelector(':scope > .bc-trust');
      if (el && el.__bcHtml === html) return;
      if (el) el.remove();
      box.insertAdjacentHTML('beforeend', html);
      box.querySelector(':scope > .bc-trust').__bcHtml = html;
    });
  }

  /* ---------- sepet özeti ---------- */
  function renderSummary() {
    var html = '';
    if (CFG.summary && lastCart && lastCart.item_count > 0) {
      var c = lastCart;
      // kopyaların "eski fiyatı" ara toplama, farkı da indirim satırına yazılır
      var cloneSave = 0;
      var original = c.items.reduce(function (s, i) {
        if (isClone(i) && CLONE_INFO[i.product_id] && CLONE_INFO[i.product_id].was > 0) {
          var was = CLONE_INFO[i.product_id].was * i.quantity;
          if (was > i.original_line_price) cloneSave += was - i.original_line_price;
          return s + Math.max(was, i.original_line_price);
        }
        return s + i.original_line_price;
      }, 0);

      // indirimleri başlığa göre topla (ürün indirimleri + sepet indirimleri)
      var discounts = [], byTitle = {};
      function addDiscount(title, amount) {
        if (!amount) return;
        if (byTitle[title] == null) { byTitle[title] = discounts.length; discounts.push({ title: title, amount: 0 }); }
        discounts[byTitle[title]].amount += amount;
      }
      c.items.forEach(function (i) {
        (i.line_level_discount_allocations || []).forEach(function (d) {
          addDiscount((d.discount_application && d.discount_application.title) || 'İndirim', d.amount);
        });
      });
      (c.cart_level_discount_applications || []).forEach(function (d) { addDiscount(d.title, d.total_allocated_amount); });
      if (cloneSave > 0) addDiscount(T.offerSaving, cloneSave);

      // kalan fark (ör. fiyat farkı) varsa toplam tutsun diye
      var discTotal = discounts.reduce(function (s, d) { return s + d.amount; }, 0);
      var gap = original - discTotal - c.total_price;
      if (gap > 0) addDiscount('İndirim', gap);

      var fee = CFG.shipping_fee || 0;
      var freeShip = CFG.free_shipping_min > 0 && c.total_price >= CFG.free_shipping_min;
      var shipKnown = CFG.free_shipping_min > 0 && fee > 0;
      var shipCost = shipKnown && !freeShip ? fee : 0;
      var total = c.total_price + shipCost;
      var saved = (original - c.total_price) + (shipKnown && freeShip ? fee : 0);

      html = '<div class="bc-sum">' +
        '<div class="bc-sum__row"><span>' + T.subtotal + '</span><span>' + money(original) + '</span></div>' +
        discounts.map(function (d) {
          return '<div class="bc-sum__row bc-sum__row--disc"><span>' + esc(d.title) + '</span><span>-' + money(d.amount) + '</span></div>';
        }).join('') +
        '<div class="bc-sum__row"><span>' + T.shipping + '</span><span>' +
          (!shipKnown ? T.shippingLater : freeShip ? '<del>' + money(fee) + '</del> ' + T.shippingFree : money(fee)) +
        '</span></div>' +
        '<div class="bc-sum__row bc-sum__row--total"><span>' + T.total + '</span><span>' + money(total) + '</span></div>' +
        (saved > 0 ? '<p class="bc-sum__saved">' + T.savings(money(saved)) + '</p>' : '') +
        '<p class="bc-sum__tax">' + T.taxNote + '</p>' +
      '</div>';
    }
    // Kutu temada elle eklenmemişse kendimiz yerleştir:
    // sepet sayfası → toplam tablosunun üstü, çekmece → indirim/ara toplam alanının başı
    document.querySelectorAll('.thb-cart-form--cart-collaterals > table.no-borders').forEach(function (tbl) {
      var box = tbl.parentNode;
      if (!box.querySelector('[data-bc-summary]')) tbl.insertAdjacentHTML('beforebegin', '<div data-bc-summary></div>');
    });
    document.documentElement.classList.toggle('bc-has-summary', !!html);
    // özet sadece sepet sayfasında; çekmece temanın kendi toplamını kullanır
    document.querySelectorAll('.cart-drawer [data-bc-summary]').forEach(function (el) { el.remove(); });
    paint('[data-bc-summary]', html);
  }

  /* ---------- progress bar ---------- */
  var ICON_GIFT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M12 8S10.5 3 8 3.5 7 8 12 8zm0 0s1.5-5 4-4.5S17 8 12 8z"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function milestones() {
    var list = [];
    if (CFG.shipping > 0) list.push({ threshold: CFG.shipping, label: T.shipLabel, ship: true });
    if (campaignActive()) CFG.gifts.forEach(function (g) { list.push({ threshold: g.threshold, label: g.label }); });
    return list.sort(function (a, b) { return a.threshold - b.threshold; });
  }

  function renderProgress() {
    var html = buildProgress(lastCart);
    document.documentElement.classList.toggle('bc-has-progress', CFG.shipping > 0 && !!html);
    paint('[data-bc-progress]', html);
  }

  function buildProgress(cart) {
    var html = '';
    if (cart && cart.item_count > 0) {
      var base = baseTotal(cart);
      var ms = milestones();
      if (ms.length) {
        var max = ms[ms.length - 1].threshold;
        var next = ms.filter(function (m) { return base < m.threshold; })[0];
        var head = !next ? T.allDone
          : next.ship ? T.remainingShip(money(next.threshold - base))
          : T.remainingGift(money(next.threshold - base), next.label);
        var pct = Math.min(100, (base / max) * 100);

        var camp = campaignActive() && CFG.gifts.length
          ? '<p class="bc-pb__camp"><span>' + esc(CAMP.name || '') + '</span><span data-bc-countdown>' + endLabel() + '</span></p>' : '';
        html = '<div class="bc-pb' + (next ? '' : ' is-complete') + '">' + camp +
          '<p class="bc-pb__head">' + head + '</p>' +
          '<div class="bc-pb__track"><div class="bc-pb__fill" style="width:' + pct.toFixed(2) + '%"></div>' +
            ms.map(function (m, idx) {
              var left = (m.threshold / max) * 100;
              var done = base >= m.threshold;
              var cls = 'bc-pb__ms' + (done ? ' is-done' : '') + (idx === ms.length - 1 ? ' is-last' : '');
              return '<div class="' + cls + '" style="left:' + left.toFixed(2) + '%">' +
                '<span class="bc-pb__dot">' + (done ? ICON_CHECK : (m.ship ? ICON_TRUCK : ICON_GIFT)) + '</span>' +
                '<span class="bc-pb__label"><strong>' + money(m.threshold, true) + '+</strong><em>' + esc(m.label) + '</em></span>' +
              '</div>';
            }).join('') +
          '</div>' +
        '</div>';
      }
    }
    return html;
  }

  /* ---------- sepete özel fırsatlar (+ reddedilen hediye için "Hediyeni seç") ---------- */
  function inCart(productIds) {
    return lastCart.items.some(function (i) { return !giftIdOf(i) && productIds.indexOf(i.product_id) !== -1; });
  }

  // Fırsat eşiği: fırsat ürünleri (Crossbody / Clutch) hariç tutar
  function offerBase(cart) {
    return cart.items.reduce(function (s, i) {
      return (giftIdOf(i) || isClone(i)) ? s : s + i.original_line_price;
    }, 0);
  }

  function renderOffers() {
    var html = '';
    if (campaignActive() && lastCart && lastCart.item_count > 0) {
      var base = baseTotal(lastCart);

      // hediye eşiği geçilmiş ama müşteri istemediyse
      CFG.gifts.forEach(function (g) {
        if (base >= g.threshold && !currentGiftLine(g.id)) {
          html += '<div class="bc-gift__cta"><span>' + esc(T.giftWaiting(g.label)) + '</span>' +
                  '<button type="button" class="bc-gift-change" data-bc-gift-open="' + esc(g.id) + '">' + T.giftWaitingBtn + '</button></div>';
        }
      });

      var O = CFG.offers;
      if (O.enabled && offerBase(lastCart) >= O.threshold) {
        var cards = O.groups.filter(function (grp) { return firstAvailable(grp.options); }).map(function (grp) {
          var selId = offerSel[grp.id];
          var sel = (selId && optionIn(grp.options, selId)) || firstAvailable(grp.options);
          offerSel[grp.id] = sel.variant_id;
          return '<div class="bc-offer" data-bc-offer="' + esc(grp.id) + '">' +
            '<div class="bc-offer__body">' +
              '<p class="bc-offer__line">' + esc(T.offerLine(grp.name, O.percent)) + '</p>' +
              '<p class="bc-offer__name">' + esc(sel.title) + '</p>' +
              '<p class="bc-offer__price"><strong>' + esc(sel.sale_price) + '</strong> <del>' + esc(sel.price) + '</del>' +
                '<span class="bc-offer__pct">' + esc(T.offerPct(O.percent)) + '</span></p>' +
              '<div class="bc-offer__swatches">' +
                grp.options.map(function (o) {
                  return '<button type="button" class="bc-offer__sw' + (o.variant_id === sel.variant_id ? ' is-active' : '') + '"' +
                    ' data-bc-offer-pick="' + o.variant_id + '"' + (o.available ? '' : ' disabled') + ' title="' + esc(o.title) + '">' +
                    (o.thumb ? '<img src="' + o.thumb + '" alt="' + esc(o.title) + '" loading="lazy" width="56" height="56">' : '') +
                  '</button>';
                }).join('') +
              '</div>' +
              '<button type="button" class="bc-offer__add" data-bc-offer-add="' + sel.variant_id + '">' + T.addToCart + '</button>' +
            '</div>' +
            (sel.image ? '<img class="bc-offer__img" src="' + sel.image + '" alt="' + esc(sel.title) + '" loading="lazy">' : '') +
          '</div>';
        });
        if (cards.length) {
          html += '<div class="bc-offers"><div class="bc-offers__head"><span class="bc-offers__title">' + T.offersTitle + '</span>' +
                  '<span class="bc-offers__badge">' + T.offersBadge + '</span></div>' + cards.join('') + '</div>';
        }
      }
    }
    paint('[data-bc-gift-picker]', html);
  }

  function paint(selector, html) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.__bcHtml !== html) { el.innerHTML = html; el.__bcHtml = html; }
    });
  }

  /* ---------- "Sepete eklendi" bildirimi ---------- */
  var TOAST_MS = 10000;         // ekranda kalma süresi (ms) — 10000 = 10 saniye
  var toast = null, toastTimer = null, toastLeft = 0, toastStart = 0, toastItem = null, toastUnlocked = [];

  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function buildToast() {
    toast = document.createElement('div');
    toast.className = 'bc-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    toast.addEventListener('mouseenter', pauseToast);
    toast.addEventListener('mouseleave', resumeToast);
    toast.addEventListener('touchstart', pauseToast, { passive: true });
  }

  function renderToast() {
    if (!toast || !toastItem) return;
    var i = toastItem;
    var price = i.final_line_price != null ? i.final_line_price : i.line_price;
    var orig = i.original_line_price != null ? i.original_line_price : price;
    var variant = i.variant_title && !/default/i.test(i.variant_title) ? i.variant_title : '';
    var count = lastCart ? lastCart.item_count : '';
    toast.innerHTML =
      '<div class="bc-toast__timer"><span></span></div>' +
      '<div class="bc-toast__head">' +
        '<span class="bc-toast__check">' + ICON_CHECK + '</span>' +
        '<span class="bc-toast__title">' + T.added + '</span>' +
        '<button type="button" class="bc-toast__x" data-bc-toast-close aria-label="Kapat">&times;</button>' +
      '</div>' +
      '<div class="bc-toast__item">' +
        (i.image ? '<img src="' + esc(imgUrl(i.image, 200)) + '" alt="" width="72" height="72">' : '') +
        '<div class="bc-toast__info">' +
          '<p class="bc-toast__name">' + esc(i.product_title || i.title) + '</p>' +
          (variant ? '<p class="bc-toast__variant">' + esc(variant) + '</p>' : '') +
          '<p class="bc-toast__price">' + (orig > price ? '<del>' + money(orig) + '</del> ' : '') + money(price) + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="bc-toast__gift"></div>' +
      '<div class="bc-toast__pb">' + buildProgress(lastCart) + '</div>' +
      '<div class="bc-toast__btns">' +
        '<a class="bc-toast__go" href="' + esc(root) + 'cart">' + T.goCart(count) + '</a>' +
        '<button type="button" class="bc-toast__keep" data-bc-toast-close>' + T.keepShopping + '</button>' +
      '</div>';
    var bar = toast.querySelector('.bc-toast__timer span');
    bar.style.animationDuration = TOAST_MS + 'ms';
    renderToastGift();
  }

  // Bu eklemeyle açılan (rengi henüz seçilmemiş) hediyeleri bildirimde göster
  function renderToastGift() {
    if (!toast) return;
    var box = toast.querySelector('.bc-toast__gift');
    if (!box) return;
    var html = CFG.gifts.filter(function (g) {
      return toastUnlocked.indexOf(g.id) !== -1 && store('bc_gift_declined_' + g.id) !== '1';
    }).map(function (g) {
      return '<div class="bc-toast__giftrow">' + ICON_GIFT +
        '<span>' + esc(T.giftUnlocked(g.label)) + '</span>' +
        '<button type="button" data-bc-toast-gift="' + esc(g.id) + '">' + T.giftPick + '</button></div>';
    }).join('');
    if (box.__bcHtml !== html) { box.innerHTML = html; box.__bcHtml = html; }
  }

  function showToast(item) {
    if (!toast) buildToast();
    toastItem = item;
    renderToast();
    toast.classList.remove('is-paused');
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastLeft = TOAST_MS;
    toastStart = Date.now();
    toastTimer = setTimeout(hideToast, toastLeft);
  }

  function hideToast() {
    clearTimeout(toastTimer);
    if (toast) toast.classList.remove('is-open', 'is-paused');
  }
  function pauseToast() {
    if (!toast || !toast.classList.contains('is-open') || toast.classList.contains('is-paused')) return;
    clearTimeout(toastTimer);
    toastLeft = Math.max(800, toastLeft - (Date.now() - toastStart));
    toast.classList.add('is-paused');
  }
  function resumeToast() {
    if (!toast || !toast.classList.contains('is-paused')) return;
    toast.classList.remove('is-paused');
    toastStart = Date.now();
    toastTimer = setTimeout(hideToast, toastLeft);
  }

  // Tema her "sepete ekle"de bu olayı gönderiyor (ürün sayfası + hızlı ekleme)
  document.addEventListener('cart:item-added', async function (e) {
    var item = e.detail && e.detail.product;
    if (!item || item.status) return;
    if (/\/cart\/?$/.test(window.location.pathname)) return; // sepet sayfasındayken gerek yok
    try { lastCart = await getCart(); } catch (err) {}
    // Bu ekleme hangi hediye eşiklerini geçirdi? (ekleme öncesi altında, şimdi üstünde)
    var qty = (e.detail && e.detail.quantity) || 1;
    var unit = item.final_price != null ? item.final_price : (item.price || 0);
    var added = giftIdOf(item) ? 0 : unit * qty;
    var now = lastCart ? baseTotal(lastCart) : 0;
    toastUnlocked = !campaignActive() ? [] : CFG.gifts.filter(function (g) { return now >= g.threshold && now - added < g.threshold; })
                             .map(function (g) { return g.id; });
    showToast(item);
  });

  /* ---------- hediye popup'ı ---------- */
  var modal = null, modalGift = null, selectedId = null;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'bc-gm';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="bc-gm__overlay" data-bc-gm-close></div>' +
      '<div class="bc-gm__panel" role="dialog" aria-modal="true">' +
        '<button type="button" class="bc-gm__x" data-bc-gm-close aria-label="Kapat">&times;</button>' +
        '<div class="bc-gm__media">' +
          '<div class="bc-gm__info"><span class="bc-gm__label">' + T.giftTag + '</span>' +
          '<span class="bc-gm__name"></span><span class="bc-gm__price"><del></del> <ins>' + T.free + '</ins></span></div>' +
          '<img class="bc-gm__img" alt="">' +
        '</div>' +
        '<div class="bc-gm__body">' +
          '<h3 class="bc-gm__title"></h3><p class="bc-gm__sub"></p>' +
          '<p class="bc-gm__caption">' + T.pick + '</p><div class="bc-gm__grid"></div>' +
          '<button type="button" class="bc-gm__cta" data-bc-gm-confirm></button>' +
          '<button type="button" class="bc-gm__decline" data-bc-gm-decline>' + T.decline + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
  }

  function selectInModal(id) {
    var o = optionIn(modalGift.options, id) || firstAvailable(modalGift.options);
    if (!o) return;
    selectedId = o.variant_id;
    modal.querySelector('.bc-gm__sub').textContent = T.subtitle(o.price);
    modal.querySelector('.bc-gm__name').textContent = o.title;
    modal.querySelector('.bc-gm__price del').textContent = o.price || '';
    var img = modal.querySelector('.bc-gm__img');
    var src = o.image || o.thumb || '';
    img.style.display = src ? '' : 'none';
    if (src) img.src = src;
    modal.querySelectorAll('.bc-gm__opt').forEach(function (b) {
      b.classList.toggle('is-active', Number(b.getAttribute('data-bc-gm-variant')) === selectedId);
    });
  }

  function openModal(giftId) {
    var gift = giftById(giftId);
    if (!gift) return;
    if (!modal) buildModal();
    preloadImages();
    modalGift = gift;
    var line = currentGiftLine(gift.id);
    modal.querySelector('.bc-gm__title').textContent = gift.title;
    modal.querySelector('.bc-gm__grid').innerHTML = gift.options.map(function (o) {
      return '<button type="button" class="bc-gm__opt" data-bc-gm-variant="' + o.variant_id + '"' +
        (o.available ? '' : ' disabled') + ' title="' + esc(o.title) + '">' +
        (o.thumb ? '<img src="' + o.thumb + '" alt="' + esc(o.title) + '" width="90" height="90">' : '<span>' + esc(o.title) + '</span>') +
      '</button>';
    }).join('');
    modal.querySelector('[data-bc-gm-confirm]').textContent = line ? T.confirmEdit : T.confirmNew;
    selectInModal(line ? line.variant_id : (firstAvailable(gift.options) || {}).variant_id);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bc-gm-lock');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bc-gm-lock');
  }

  /* ---------- tıklamalar ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el;

    if (t.closest('[data-bc-toast-close]')) { e.preventDefault(); hideToast(); return; }
    if ((el = t.closest('[data-bc-toast-gift]'))) {
      e.preventDefault(); e.stopPropagation();
      var tg = el.getAttribute('data-bc-toast-gift');
      hideToast(); markSeen(tg); openModal(tg);
      return;
    }
    if ((el = t.closest('[data-bc-gift-open]'))) { e.preventDefault(); e.stopPropagation(); markSeen(el.getAttribute('data-bc-gift-open')); openModal(el.getAttribute('data-bc-gift-open')); return; }

    if ((el = t.closest('[data-bc-offer-pick]'))) {
      e.preventDefault(); e.stopPropagation();
      if (el.disabled) return;
      var card = el.closest('[data-bc-offer]');
      offerSel[card.getAttribute('data-bc-offer')] = Number(el.getAttribute('data-bc-offer-pick'));
      renderOffers();
      return;
    }
    if ((el = t.closest('[data-bc-offer-add]'))) { e.preventDefault(); e.stopPropagation(); addOffer(Number(el.getAttribute('data-bc-offer-add')), el); return; }

    if (!modal || !modal.contains(t)) return;
    if ((el = t.closest('[data-bc-gm-variant]'))) { if (!el.disabled) selectInModal(Number(el.getAttribute('data-bc-gm-variant'))); return; }
    if (t.closest('[data-bc-gm-confirm]')) { var gid = modalGift.id, vid = selectedId; closeModal(); applyChoice(gid, vid); return; }
    if (t.closest('[data-bc-gm-decline]')) { var did = modalGift.id; closeModal(); declineGift(did); return; }
    if (t.closest('[data-bc-gm-close]')) closeModal();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  /* ---------- temanın sepet işlemlerini dinle ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function () { setTimeout(sync, 0); }, function () {});
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__bcCart = CART_RE.test(String(url)); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__bcCart) this.addEventListener('loadend', function () { setTimeout(sync, 0); });
    return xSend.apply(this, arguments);
  };

  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 30); })
    .observe(document.body, { childList: true, subtree: true });

  sync();
})();
